module.exports = __webpack_public_path__ + "media/assets/images/maple/slider1-03b60e74c18e0438eb7f62bcd49f2176.jpg";